export const ARTICULOS_REQUEST = "ARTICULOS_REQUEST";
export const ARTICULOS_OK = "ARTICULOS_OK";
export const ARTICULOS_REFRESH = "ARTICULOS_REFRESH";
export const ARTICULOS_ERROR = "ARTICULOS_ERROR";
